import Vue from 'vue'
import Card from '../../components/CardForContent/CardForContent.vue'
import AffiliateStatisticsChart from './AffiliateStatisticsChart';
import Status from '../../components/Status/Status.vue'
import BaseButton from '../../components/BaseButton/BaseButton.vue'
import Pagination from '../../components/Pagination/Pagination.vue'
import WithdrawalModal from '../../components/AffiliateModal/WithdrawalModal.vue'
import ClickTable from './ClickSignUpTable.vue'
import TransactionsTable from './TransactionsTable.vue'
import WithdrawalTable from './WithdrawalTable.vue'
export default Vue.extend({
    name: "AffiliateProgram",
    components: {
        Card,
        'affiliate-statistics-chart': AffiliateStatisticsChart,
        Status,
        BaseButton,
        WithdrawalModal,
        ClickTable,
        TransactionsTable,
        WithdrawalTable,
        Pagination
    },
    data() {
        return {
            slides: [1,2],
            withdrawal_table: false,
            click_table: false,
            transaction_table: false,
            clicked: false,
            withdrawals: [
                /*{
                    date: '2021-02-18',
                    amount: 69.30,
                    status: 'pending',
                    wallet: 'Tapmixer Balance',
                    id: 0
                },
                {
                    date: '2021-02-18',
                    amount: 69.30,
                    status: 'paid',
                    wallet: 'Tapmixer Balance',
                    id: 1
                },
                {
                    date: '2021-02-18',
                    amount: 69.30,
                    status: 'declined',
                    wallet: 'Tapmixer Balance',
                    id: 2
                }*/
            ],
            transactions: [
                {
                    date: '2021-02-18',
                    payout: 69.30,
                    status: 'pending',
                    id: 0
                },
                {
                    date: '2021-02-18',
                    payout: 69.30,
                    status: 'payable',
                    id: 1
                },
                {
                    date: '2021-02-18',
                    payout: 69.30,
                    status: 'declined',
                    id: 2
                },
            ],
            chart_options: {
                    maintainAspectRatio: false,
                    responsive: true,
                    tooltips: {
                        mode: 'index',
                        intersect: false,
                        position: 'custom'
                    },
                    hover: {
                        mode: 'nearest',
                        intersect: true
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    legend: {
                            display: false
                        }
                },
            chart_styles: {
                    height: '300px',
                    width: '100%',
                    position: 'relative'
                },
            info:{
                payable: 554.40,
                pending: 714.40,
                earned: 2851,
                purchases: 88,
                clicks: 1261,
                sign_ups: 485
            }
        }
    },
    computed: {
        table() {
            return (this.withdrawal_table || this.click_table || this.transaction_table)
        },
        chart_data(){
            let datasets = [];
                datasets[0] = {
                    borderColor:"#4A6C8E",
                    backgroundColor:"#4A6C8E",
                    borderWidth: 1,
                    fill:false,
                    label: 'Clicks',
                    pointRadius: 2,
                    data : [1, 2, 1, 4, 3, 4, 5, 6, 4, 8, 6],
                    lineTension: 0,
                    };
        return {
            labels: ['05/15', '05/16', '05/17', '05/18', '05/19', '05/20', '05/21', '05/22', '05/23', '05/24'],
            // date_range: dateRange,
            datasets: datasets,
            }
        },
        chart_data_sign_up(){
            let datasets = [];
                datasets[0] = {
                    borderColor:"#00A65A",
                    backgroundColor:"#00A65A",
                    borderWidth: 1,
                    fill:false,
                    label: 'Clicks',
                    pointRadius: 2,
                    data : [1.0, 2.0, 1.0, 4.0, 3.0, 4.0, 5.0, 6.0, 4.0, 8.0, 6.0],
                    lineTension: 0,
                    };
        return {
            labels: ['05/15', '05/16', '05/17', '05/18', '05/19', '05/20', '05/21', '05/22', '05/23', '05/24'],
            // date_range: dateRange,
            datasets: datasets,
            }
        }
    },
    methods: {
        change(value) {
            this.clicked = value
        },
    }
})